<template>
  <div class="home-container">
    <el-header id="app-header">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="12" :md="12" :lg="12">
          <h2>Metaleks订单流程系统</h2>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" style="text-align: right;">
          <span>欢迎，{{ user.real_name }} ({{ user.position }})</span>
          <el-button type="text" @click="logout" class="logout-btn">退出</el-button>
        </el-col>
      </el-row>
    </el-header>
    <el-tabs ref="tabsRef" v-model="activeTab" @tab-click="handleTabClick" class="content-tabs">
      <!-- 店铺订单 Tab -->
      <el-tab-pane label="动漫1站 (ANI)" name="ANI">
        <DataTable ref="dataTableANI" storePrefix="ANI" storeName="动漫1站" syncApi="syncANI" />
      </el-tab-pane>
      <el-tab-pane label="Metaleks (CMP)" name="CMP">
        <DataTable ref="dataTableCMP" storePrefix="CMP" storeName="Metaleks" syncApi="syncCMP" />
      </el-tab-pane>
      <el-tab-pane label="OTA Poster (OTA)" name="OTA">
        <DataTable ref="dataTableOTA" storePrefix="OTA" storeName="OTA Poster" syncApi="syncOTA" />
      </el-tab-pane>
      <el-tab-pane label="Bettermelab (MPS)" name="MPS">
        <DataTable ref="dataTableMPS" storePrefix="MPS" storeName="Bettermelab" syncApi="syncMPS" />
      </el-tab-pane>
      <el-tab-pane label="Animetallic (ALIC)" name="ALIC">
        <DataTable ref="dataTableALIC" storePrefix="ALIC" storeName="Animetallic" syncApi="syncALIC" />
      </el-tab-pane>
      <!-- 退回表 Tab -->
      <el-tab-pane label="退回表" name="return">
        <ReturnTable ref="returnTable" @switchToReturnTab="switchToReturnTab" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import DataTable from '../components/DataTable.vue';
import ReturnTable from '../components/ReturnTable.vue';

export default {
  components: {
    DataTable,
    ReturnTable
  },
  data() {
    return {
      activeTab: 'ANI',
      tabNavMargin: 70,
      user: this.$store.state.user || {},
      headerHeight: 80,
      isHeaderFixed: false
    };
  },
  mounted() {
    this.updateTabNavMargin();
    this.updateHeaderHeight();
    window.addEventListener('resize', this.updateTabNavMargin);
    window.addEventListener('resize', this.updateHeaderHeight);
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateTabNavMargin);
    window.removeEventListener('resize', this.updateHeaderHeight);
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleTabClick() {
      if (this.activeTab === 'return') {
        this.$refs.returnTable.checkNotifications();
      }
      this.updateTabNavMargin();
    },
    switchToReturnTab() {
      this.activeTab = 'return';
      this.updateTabNavMargin();
    },
    logout() {
      this.$store.dispatch('logout');
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      this.$router.push('/login');
    },
    updateTabNavMargin() {
      const width = window.innerWidth;
      this.tabNavMargin = width <= 768 ? 10 : 70;
      const tabNav = this.$refs.tabsRef.$el.querySelector('.el-tabs__nav');
      if (tabNav) {
        tabNav.style.marginLeft = `${this.tabNavMargin}px`;
      }
    },
    updateHeaderHeight() {
      const width = window.innerWidth;
      this.headerHeight = width <= 768 ? 60 : 80;
    },
    handleScroll() {
      const header = document.getElementById('app-header');
      if (!header) return;

      const headerOffsetTop = header.offsetTop;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > headerOffsetTop) {
        if (!this.isHeaderFixed) {
          this.isHeaderFixed = true;
          header.style.position = 'fixed';
          header.style.top = '0';
          header.style.left = '0';
          header.style.right = '0';
          header.style.zIndex = '1000';
          document.querySelector('.content-tabs').style.marginTop = `${this.headerHeight}px`;
        }
      } else {
        if (this.isHeaderFixed) {
          this.isHeaderFixed = false;
          header.style.position = '';
          header.style.top = '';
          header.style.left = '';
          header.style.right = '';
          header.style.zIndex = '';
          document.querySelector('.content-tabs').style.marginTop = '0';
        }
      }
    }
  }
};
</script>

<style scoped>
.home-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f7fa;
}

.el-header {
  background-color: #409EFF;
  color: #fff;
  line-height: 80px;
  height: 80px !important;
  padding: 0 20px;
}

.el-header h2 {
  margin: 0;
  font-size: 1.5rem;
}

.content-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: margin-top 0.3s ease;
}

.el-tabs__content {
  flex: 1;
  overflow: auto;
}

.el-tab-pane {
  height: 100%;
  overflow: auto;
  padding: 10px;
  box-sizing: border-box;
}

.logout-btn {
  padding: 10px 20px;
  font-size: 1rem;
}

/* 手机端样式调整 */
@media screen and (max-width: 768px) {
  .el-header {
    height: 60px !important;
    line-height: 60px;
    padding: 0 10px;
  }
  .el-header h2 {
    font-size: 1.2rem;
  }
  .el-tab-pane {
    padding: 5px;
  }
  .logout-btn {
    font-size: 0.9rem;
  }
}
</style>
